import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { HomePage } from "./../home/home";
import { Storage } from "@ionic/storage";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-shopper-requrement",
  templateUrl: "shopper-requrement.html",
})
export class ShopperRequrementPage {
  // @ViewChild(TimerComponent) timer: TimerComponent;

  timeInSeconds: any = 0;
  finishTime: any;
  currentTime: any;
  interval: any;
  plaza_name: any;
  shopper_team_name = "";
  plaza: any = "";
  no = "";
  label = "";
  timer: any;
  maxTime: any = 10;
  displayTime: any;
  pauseTimer: boolean = false;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private http: Http,
    private services: ServiceProvider
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.storage.get("info").then((info) => {
      if (info.role == 1) {
        this.label = "PLAZA";
        this.plaza_name = info.team.plaza_id;
        if (this.plaza_name == 1) {
          this.no = "A";
        } else if (this.plaza_name == 2) {
          this.no = "B";
        } else if (this.plaza_name == 3) {
          this.no = "C";
        } else if (this.plaza_name == 4) {
          this.no = "D";
        } else if (this.plaza_name == 5) {
          this.no = "E";
        } else if (this.plaza_name == 6) {
          this.no = "F";
        }
      } else if (info.role == 2) {
        this.label = "MERCHANT";
        this.no = info.team.merchant_id;
      } else {
        this.label = "SHOPPER";
        this.shopper_team_name = info.team.shopper_team_name;
      }
    });

    this.storage.get("token").then((token) => {
      var headers = new Headers();
      headers.append("Content-Type", "application/x-www-form-urlencoded");
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });
      var link = this.services.URLUserStatEnd;
      // let body =  "round=1&step=4";

      this.http
        .post(link, "", requestOptions)
        .map((res) => res.json())
        .subscribe((data2) => {
          // this.timer.startTimer();

          var link = this.services.URLCheckStep;
          this.http
            .get(link, requestOptions)
            .map((res) => res.json())
            .subscribe((data) => {
              // console.log("next_step_time=",data.next_step_time);

              var currentTime = new Date();
              let dateString =
                data.next_step_time.split(" ")[0] +
                "T" +
                data.next_step_time.split(" ")[1];
              var finishTime = new Date(dateString);
              // var finishTime = new Date("2022-02-18T05:22:37.327Z");
              // console.log("dateString=",dateString);
              // console.log("finishTime=",finishTime);

              if (currentTime < finishTime) {
                let diff = finishTime.getTime() - currentTime.getTime();
                // console.log("currentTime get =",currentTime.getTime());
                // console.log("finishTime get=",finishTime.getTime());
                // console.log("diff=",diff);

                var days = Math.floor(diff / (60 * 60 * 24 * 1000));
                var hours = Math.floor(diff / (60 * 60 * 1000)) - days * 24;
                var minutes =
                  Math.floor(diff / (60 * 1000)) -
                  (days * 24 * 60 + hours * 60);
                var seconds =
                  Math.floor(diff / 1000) -
                  (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60);
                let total_seconds = seconds;

                if (minutes > 0) {
                  total_seconds += minutes * 60;
                }
                if (hours > 0) {
                  total_seconds += hours * 60 * 60;
                }

                this.maxTime = total_seconds;

                // console.log("maxTime=",this.maxTime);

                this.displayTime = this.getSecondsAsDigitalClock(this.maxTime);
                this.StartTimer();
              }
            });
        });
    });
  }

  getSecondsAsDigitalClock(inputSeconds: number) {
    var sec_num = parseInt(inputSeconds.toString(), 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;
    var hoursString = "";
    var minutesString = "";
    var secondsString = "";
    hoursString = hours < 10 ? "0" + hours : hours.toString();
    minutesString = minutes < 10 ? "0" + minutes : minutes.toString();
    secondsString = seconds < 10 ? "0" + seconds : seconds.toString();
    if (hoursString == "00" && minutesString == "00") {
      return "00:" + secondsString;
    } else if (hoursString == "00" && minutesString != "00") {
      return minutesString + ":" + secondsString;
    } else {
      return hoursString + ":" + minutesString + ":" + secondsString;
    }
  }

  StartTimer() {
    this.timer = setTimeout((x) => {
      if (this.maxTime <= 0) {
      }
      this.maxTime -= 1;
      this.displayTime = this.getSecondsAsDigitalClock(this.maxTime);

      if (this.maxTime > 0 && this.pauseTimer == false) {
        this.StartTimer();
      } else {
        this.storage.get("token").then((token) => {
          var link2 = this.services.URLUserStatEnd;

          var headers = new Headers();
          headers.append("Content-Type", "application/x-www-form-urlencoded");
          headers.append("Accept", "application/json");
          headers.append("Authorization", "Bearer " + token);
          const requestOptions = new RequestOptions({ headers: headers });

          this.http
            .post(link2, "", requestOptions)
            .map((res) => res.json())
            .subscribe((data2) => {
              this.storage.get("info").then((info) => {
                if (info.role == 1) {
                  this.navCtrl.setRoot(HomePage, {});
                } else if (info.role == 2) {
                  this.navCtrl.setRoot(MerchantHomePage, {});
                } else if (info.role == 3) {
                  this.navCtrl.setRoot(ShopperHomePage, {});
                }
              });
            });
        });
      }
    }, 1000);
  }

  backPage() {
    this.pauseTimer = true;
    this.storage.get("info").then((info) => {
      if (info.role == 1) {
        this.navCtrl.setRoot(HomePage);
      } else if (info.role == 2) {
        this.navCtrl.setRoot(MerchantHomePage);
      } else if (info.role == 3) {
        this.navCtrl.setRoot(ShopperHomePage);
      }
    });
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.pauseTimer = true;
    this.storage.get("info").then((info) => {
      if (info.role == 1) {
        this.navCtrl.setRoot(HomePage);
      } else if (info.role == 2) {
        this.navCtrl.setRoot(MerchantHomePage);
      } else if (info.role == 3) {
        this.navCtrl.setRoot(ShopperHomePage);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-requrement/shopper-requrement.ts